import "@/App.css";
import { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { isBabyPatient } from "@/lib/utils";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import SlotConflictDialog from "@/components/SlotConflictDialog";
import { ConfirmDialogsProvider } from "@/components/ConfirmDialogs";
import { Toaster } from "@/components/ui/sonner";
import axios from "axios";
import Layout from "@/components/Layout";
import AdminLayout from "@/components/AdminLayout";
import ViewerLayout from "@/components/ViewerLayout";
import ColaboradorLayout from "@/components/ColaboradorLayout";
import MarketingLayout from "@/components/MarketingLayout";
import ViewerDashboardPage from "@/pages/viewer/ViewerDashboardPage";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import DashboardPage from "@/pages/DashboardPage";
import EmentaPage from "@/pages/EmentaPage";
import ComprasPage from "@/pages/ComprasPage";
import DiarioPage from "@/pages/DiarioPage";
import CheckinPage from "@/pages/CheckinPage";
import ReceitasPage from "@/pages/ReceitasPage";
import MinhasReceitasPage from "@/pages/MinhasReceitasPage";
import PerimetrosPage from "@/pages/PerimetrosPage";
import AlimentosPage from "@/pages/AlimentosPage";
import PlanosPage from "@/pages/PlanosPage";
import { InicioHub, MensagensHub, QuestionariosHub, FormulariosHub, ReceitasHub, AlimentosHub, SuplementacaoHub, MateriaisHub, MarketingHub, MetricasHub, FinanceiroHub, ComunicacoesHub, ConfiguracoesHub, DadosHub } from "@/pages/admin/hubs";
import { HubRedirect } from "@/components/admin/HubPage";
import PacientesPage from "@/pages/admin/PacientesPage";
import PacienteDetailPage from "@/pages/admin/PacienteDetailPage";
import EquivalentesPage from "@/pages/admin/EquivalentesPage";
import ImportPacientesPage from "@/pages/admin/ImportPacientesPage";
import ConteudosPage from "@/pages/ConteudosPage";
import EvolucaoPage from "@/pages/EvolucaoPage";
import PagamentosClientePage from "@/pages/PagamentosClientePage";
import PassosPage from "@/pages/PassosPage";
import GlicemiaPage from "@/pages/GlicemiaPage";
import AguaPage from "@/pages/AguaPage";
import AtividadePage from "@/pages/AtividadePage";
import CommunityRecipesPage from "@/pages/CommunityRecipesPage";
import RecursosPage from "@/pages/RecursosPage";
import AdminConteudosPage from "@/pages/admin/AdminConteudosPage";
import AdminDesafiosPage from "@/pages/admin/AdminDesafiosPage";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage";
import OnboardingPage from "@/pages/OnboardingPage";
import AlertasPage from "@/pages/AlertasPage";
import MetasPage from "@/pages/MetasPage";
import DefinicoesPage from "@/pages/DefinicoesPage";
import InformacaoLegalPage from "@/pages/InformacaoLegalPage";
import ProgramaPage from "@/pages/ProgramaPage";
import AdminOnboardingPage from "@/pages/admin/AdminOnboardingPage";
import AdminFormsPage from "@/pages/admin/AdminFormsPage";
import AdminFormBuilderPage from "@/pages/admin/AdminFormBuilderPage";
import AdminFormResponsesPage from "@/pages/admin/AdminFormResponsesPage";
import PublicFormPage from "@/pages/PublicFormPage";
import SuplementacaoPage from "@/pages/SuplementacaoPage";
import GuiaPage from "@/pages/GuiaPage";
import SharedViewPage from "@/pages/SharedViewPage";
import BookingPage from "@/pages/BookingPage";
import PayPage from "@/pages/PayPage";
import WaitlistPublicPage from "@/pages/WaitlistPublicPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsConditionsPage from "@/pages/TermsConditionsPage";
import CancellationPolicyPage from "@/pages/CancellationPolicyPage";
import PainelInicialPage from "@/pages/admin/PainelInicialPage";
import EmailsPage from "@/pages/admin/EmailsPage";
import MinhaContaPage from "@/pages/admin/MinhaContaPage";
import CalendarioPage from "@/pages/admin/CalendarioPage";
import AdminSchedulePage from "@/pages/admin/AdminSchedulePage";
import AdminBackupPage from "@/pages/admin/AdminBackupPage";
import ApagadosRecentementePage from "@/pages/admin/ApagadosRecentementePage";
import AdminTeamPage from "@/pages/admin/AdminTeamPage";
import WhatsAppPage from "@/pages/admin/WhatsAppPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import BabyFoodsPage from "@/pages/admin/BabyFoodsPage";
import BabyMenuClientPage from "@/pages/BabyMenuClientPage";
import ChecklistIntroPage from "@/pages/ChecklistIntroPage";
import BillingPage from "@/pages/admin/BillingPage";
import PagamentosPage from "@/pages/admin/PagamentosPage";
import NotificacoesPage from "@/pages/admin/NotificacoesPage";
import RecomendacoesPage from "@/pages/admin/RecomendacoesPage";
import ProtocolosPage from "@/pages/admin/ProtocolosPage";
import ModelosPage from "@/pages/admin/ModelosPage";
import AnamneseEditorPage from "@/pages/admin/AnamneseEditorPage";
import PreConsultaPage from "@/pages/admin/PreConsultaPage";
import PreConsultationAuditPage from "@/pages/admin/PreConsultationAuditPage";
import MensagensAdminPage from "@/pages/admin/MensagensAdminPage";
import PreConsultaOnboarding from "@/pages/PreConsultaOnboarding";
import MensagensClientPage from "@/pages/MensagensClientPage";
import ComposicaoPage from "@/pages/ComposicaoPage";
import CicloPage from "@/pages/CicloPage";
import SuplementacaoTemplatesPage from "@/pages/admin/SuplementacaoTemplatesPage";
import SupplementLibraryPage from "@/pages/admin/SupplementLibraryPage";
import DesempenhoPage from "@/pages/admin/DesempenhoPage";
import FinanceiroPage from "@/pages/admin/FinanceiroPage";
import TarefasPage from "@/pages/admin/TarefasPage";
import TaskSettingsPage from "@/pages/admin/TaskSettingsPage";
import CeoDashboardPage from "@/pages/admin/CeoDashboardPage";
import CeoMonthlyMetricsPage from "@/pages/admin/CeoMonthlyMetricsPage";
import MetricasAvancadasPage from "@/pages/admin/MetricasAvancadasPage";
import FinanceiroHubPage from "@/pages/admin/FinanceiroHubPage";
import PersonalFinanceHubPage from "@/pages/admin/PersonalFinance/PersonalFinanceHubPage";
import NutriChequesPage from "@/pages/admin/NutriCheques/NutriChequesPage";
import MetricasHubPage from "@/pages/admin/MetricasHubPage";
import DisponibilidadePage from "@/pages/admin/DisponibilidadePage";
import HelpPage from "@/pages/admin/HelpPage";
import AdminRecipesPage from "@/pages/admin/AdminRecipesPage";
import AdminEmentaFixaPage from "@/pages/admin/AdminEmentaFixaPage";
import AdminFeedbackPage from "@/pages/admin/AdminFeedbackPage";
import ExpenseCategoriesPage from "@/pages/admin/ExpenseCategoriesPage";
import TeamPaymentsPage from "@/pages/admin/TeamPaymentsPage";
import MeusPagamentosPage from "@/pages/admin/MeusPagamentosPage";
import PatientCategoriesPage from "@/pages/admin/PatientCategoriesPage";
import ContentCasesPage from "@/pages/admin/ContentCasesPage";
import AdminDiariosPage from "@/pages/admin/AdminDiariosPage";
import RecomendacoesClientPage from "@/pages/RecomendacoesClientPage";
import GuidesEditorPage from "@/pages/admin/GuidesEditorPage";
import ComoUsarPage from "@/pages/ComoUsarPage";
import MyReceiptsPage from "@/pages/MyReceiptsPage";
import MyMonthlyReportsPage from "@/pages/MyMonthlyReportsPage";
import FeedbackConsultaPage from "@/pages/FeedbackConsultaPage";
import ClinicoClientePage from "@/pages/ClinicoClientePage";
import AnalisesClientePage from "@/pages/AnalisesClientePage";
import ListaEsperaPage from "@/pages/admin/ListaEsperaPage";
import PaymentSettingsPage from "@/pages/admin/PaymentSettingsPage";
import MenusMigradosPage from "@/pages/admin/MenusMigradosPage";
import PacientesSemNutricionistaPage from "@/pages/admin/PacientesSemNutricionistaPage";
import BabyRecipeBankPage from "@/pages/admin/BabyRecipeBankPage";
import CompararMenusBebePage from "@/pages/admin/CompararMenusBebePage";
import SessoesGratuitasPage from "@/pages/admin/SessoesGratuitasPage";
import CalendarioEditorialPage from "@/pages/admin/CalendarioEditorialPage";

function EmentaRoute() {
  const { user } = useAuth();
  if (user?.role === 'cliente' && isBabyPatient(user) && user?.has_adult_plan !== true) return <Navigate to="/ementa-bebe" replace />;
  return <EmentaPage />;
}

function ProtectedRoute({ children, skipLayout }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [onboardingChecked, setOnboardingChecked] = useState(false);
  const [needsOnboarding, setNeedsOnboarding] = useState(false);
  const [needsPreConsult, setNeedsPreConsult] = useState(false);
  const checkedRef = useRef(false);

  useEffect(() => {
    if (checkedRef.current) return;
    if (!user || user.role === 'admin' || user.role === 'nutricionista' || user.role === 'colaborador' || user.role === 'marketing_editor' || user.role === 'marketing_viewer') { setOnboardingChecked(true); return; }
    // Check cache first to avoid loop after completing onboarding
    try {
      if (sessionStorage.getItem('onboarding_done') === 'true' && sessionStorage.getItem('preconsult_done') === 'true') { setOnboardingChecked(true); return; }
    } catch {}
    checkedRef.current = true;
    (async () => {
      try {
        const [obRes, pcRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/onboarding/status`),
          axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/pre-consultation/status`),
        ]);
        const needsOb = !obRes.data.completed;
        setNeedsOnboarding(needsOb);
        if (!needsOb) try { sessionStorage.setItem('onboarding_done', 'true'); } catch {}
        // Pre-consultation: só bloqueia se existir template, ainda não foi preenchido, E for
        // genuinamente a 1ª consulta de sempre (bugfix: não disparar outra vez só porque o
        // patient_type mudou — cliente antiga não deve ver isto de novo).
        const needsPC = pcRes.data.has_template && !pcRes.data.completed && pcRes.data.is_first_consultation_ever;
        setNeedsPreConsult(needsPC);
        if (!needsPC) try { sessionStorage.setItem('preconsult_done', 'true'); } catch {}
      } catch {}
      setOnboardingChecked(true);
    })();
  }, [user]);

  if (loading || !onboardingChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bg">
        <div className="animate-pulse text-brand-green font-heading text-xl" data-testid="loading-indicator">A carregar...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === 'viewer') return <Navigate to="/viewer/dashboard" replace />;
  if (user.role === 'colaborador') return <Navigate to="/colaborador/tarefas" replace />;
  if (user.role === 'marketing_editor' || user.role === 'marketing_viewer') return <Navigate to="/marketing/calendario" replace />;
  if (needsOnboarding && !skipLayout) return <Navigate to="/onboarding" replace />;
  if (needsPreConsult && !skipLayout) return <Navigate to="/pre-consulta" replace />;
  if (skipLayout) return children;
  return <Layout><ErrorBoundary key={location.pathname}>{children}</ErrorBoundary></Layout>;
}

function AdminRoute({ children, adminOnly }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bg">
        <div className="animate-pulse text-brand-green font-heading text-xl">A carregar...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin' && user.role !== 'nutricionista') {
    const dest = user.role === 'colaborador' ? '/colaborador/tarefas' : user.role === 'viewer' ? '/viewer/dashboard' : (user.role === 'marketing_editor' || user.role === 'marketing_viewer') ? '/marketing/calendario' : '/dashboard';
    return <Navigate to={dest} replace />;
  }
  if (adminOnly && user.role !== 'admin') return <Navigate to="/admin/inicio" replace />;
  return <AdminLayout><ErrorBoundary key={location.pathname}>{children}</ErrorBoundary></AdminLayout>;
}

function MarketingRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bg">
        <div className="animate-pulse text-brand-green font-heading text-xl">A carregar...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'marketing_editor' && user.role !== 'marketing_viewer') {
    const dest = (user.role === 'admin' || user.role === 'nutricionista') ? '/admin/inicio' : (user.role === 'viewer' ? '/viewer/dashboard' : user.role === 'colaborador' ? '/colaborador/tarefas' : '/dashboard');
    return <Navigate to={dest} replace />;
  }
  return <MarketingLayout><ErrorBoundary key={location.pathname}>{children}</ErrorBoundary></MarketingLayout>;
}

function ColaboradorRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bg">
        <div className="animate-pulse text-brand-green font-heading text-xl">A carregar...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'colaborador') {
    const dest = (user.role === 'admin' || user.role === 'nutricionista') ? '/admin/inicio' : (user.role === 'viewer' ? '/viewer/dashboard' : '/dashboard');
    return <Navigate to={dest} replace />;
  }
  return <ColaboradorLayout><ErrorBoundary key={location.pathname}>{children}</ErrorBoundary></ColaboradorLayout>;
}

function ViewerRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bg">
        <div className="animate-pulse text-brand-green font-heading text-xl">A carregar...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'viewer') {
    const dest = (user.role === 'admin' || user.role === 'nutricionista') ? '/admin/inicio' : '/dashboard';
    return <Navigate to={dest} replace />;
  }
  return <ViewerLayout><ErrorBoundary key={location.pathname}>{children}</ErrorBoundary></ViewerLayout>;
}

function AppRouter() {
  const location = useLocation();
  const { user } = useAuth();
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  // Default redirect based on role
  const defaultRoute = (user?.role === 'admin' || user?.role === 'nutricionista') ? '/admin/inicio' : (user?.role === 'viewer' ? '/viewer/dashboard' : (user?.role === 'colaborador' ? '/colaborador/tarefas' : (user?.role === 'marketing_editor' || user?.role === 'marketing_viewer') ? '/marketing/calendario' : '/dashboard'));

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="/partilha/:token" element={<SharedViewPage />} />
      <Route path="/agendarconsulta" element={<BookingPage />} />
      <Route path="/pagar/:token" element={<PayPage />} />
      <Route path="/agendarconsulta/:slug" element={<BookingPage />} />
      <Route path="/listadeespera" element={<WaitlistPublicPage />} />
      <Route path="/f/:slug" element={<PublicFormPage />} />
      <Route path="/privacidade" element={<PrivacyPolicyPage />} />
      <Route path="/termos-e-condicoes" element={<TermsConditionsPage />} />
      <Route path="/politica-cancelamento" element={<CancellationPolicyPage />} />
      <Route path="/" element={<Navigate to={defaultRoute} replace />} />

      {/* Client routes */}
      <Route path="/ementa" element={<ProtectedRoute><EmentaRoute /></ProtectedRoute>} />
      <Route path="/onboarding" element={<ProtectedRoute skipLayout><OnboardingPage /></ProtectedRoute>} />
      <Route path="/pre-consulta" element={<ProtectedRoute skipLayout><PreConsultaOnboarding onComplete={() => { try { sessionStorage.setItem('preconsult_done', 'true'); } catch {} window.location.href = '/dashboard'; }} /></ProtectedRoute>} />
      <Route path="/compras" element={<ProtectedRoute><ComprasPage /></ProtectedRoute>} />
      <Route path="/diario" element={<ProtectedRoute><DiarioPage /></ProtectedRoute>} />
      <Route path="/checkin" element={<ProtectedRoute><CheckinPage /></ProtectedRoute>} />
      <Route path="/receitas" element={<ProtectedRoute><ReceitasPage /></ProtectedRoute>} />
      <Route path="/minhas-receitas" element={<ProtectedRoute><MinhasReceitasPage /></ProtectedRoute>} />
      <Route path="/perimetros" element={<ProtectedRoute><PerimetrosPage /></ProtectedRoute>} />
      <Route path="/planos" element={<ProtectedRoute><PlanosPage /></ProtectedRoute>} />
      <Route path="/conteudos" element={<ProtectedRoute><ConteudosPage /></ProtectedRoute>} />
      <Route path="/evolucao" element={<ProtectedRoute><EvolucaoPage /></ProtectedRoute>} />
      <Route path="/pagamentos" element={<ProtectedRoute><PagamentosClientePage /></ProtectedRoute>} />
      <Route path="/passos" element={<ProtectedRoute><PassosPage /></ProtectedRoute>} />
      <Route path="/glicemia" element={<ProtectedRoute><GlicemiaPage /></ProtectedRoute>} />
      <Route path="/agua" element={<ProtectedRoute><AguaPage /></ProtectedRoute>} />
      <Route path="/atividade" element={<ProtectedRoute><AtividadePage /></ProtectedRoute>} />
      <Route path="/receitas-comunidade" element={<ProtectedRoute><CommunityRecipesPage /></ProtectedRoute>} />
      <Route path="/recursos" element={<ProtectedRoute><RecursosPage /></ProtectedRoute>} />
      <Route path="/alertas" element={<ProtectedRoute><AlertasPage /></ProtectedRoute>} />
      <Route path="/metas" element={<ProtectedRoute><MetasPage /></ProtectedRoute>} />
      <Route path="/definicoes" element={<ProtectedRoute><DefinicoesPage /></ProtectedRoute>} />
      <Route path="/informacao-legal" element={<ProtectedRoute><InformacaoLegalPage /></ProtectedRoute>} />
      <Route path="/programa" element={<ProtectedRoute><ProgramaPage /></ProtectedRoute>} />
      <Route path="/suplementacao" element={<ProtectedRoute><SuplementacaoPage /></ProtectedRoute>} />
      <Route path="/guia" element={<ProtectedRoute><GuiaPage /></ProtectedRoute>} />
      <Route path="/ementa-bebe" element={<ProtectedRoute><BabyMenuClientPage /></ProtectedRoute>} />
      <Route path="/checklist-intro" element={<ProtectedRoute><ChecklistIntroPage /></ProtectedRoute>} />
      <Route path="/recomendacoes" element={<ProtectedRoute><RecomendacoesClientPage /></ProtectedRoute>} />
      <Route path="/como-usar" element={<ProtectedRoute><ComoUsarPage /></ProtectedRoute>} />
      <Route path="/mensagens" element={<ProtectedRoute><MensagensClientPage /></ProtectedRoute>} />
      <Route path="/composicao" element={<ProtectedRoute><ComposicaoPage /></ProtectedRoute>} />
      <Route path="/ciclo" element={<ProtectedRoute><CicloPage /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/recibos" element={<ProtectedRoute><MyReceiptsPage /></ProtectedRoute>} />
      <Route path="/relatorios" element={<ProtectedRoute><MyMonthlyReportsPage /></ProtectedRoute>} />
      <Route path="/feedback-consulta/:consultationId" element={<ProtectedRoute><FeedbackConsultaPage /></ProtectedRoute>} />
      <Route path="/clinico" element={<ProtectedRoute><ClinicoClientePage /></ProtectedRoute>} />
      <Route path="/analises" element={<ProtectedRoute><AnalisesClientePage /></ProtectedRoute>} />

      {/* Admin/Nutritionist routes */}
      <Route path="/admin/inicio" element={<AdminRoute><InicioHub /></AdminRoute>} />
      <Route path="/admin/dashboard" element={<HubRedirect to="/admin/inicio" separador="hoje" />} />
      <Route path="/admin/pacientes" element={<AdminRoute><PacientesPage /></AdminRoute>} />
      <Route path="/admin/pacientes/:userId" element={<AdminRoute><PacienteDetailPage /></AdminRoute>} />
      <Route path="/admin/planos" element={<AdminRoute><PlanosPage /></AdminRoute>} />
      <Route path="/admin/receitas" element={<AdminRoute><ReceitasHub /></AdminRoute>} />
      <Route path="/admin/alimentos" element={<AdminRoute><AlimentosHub /></AdminRoute>} />
      <Route path="/admin/equivalentes" element={<HubRedirect to="/admin/alimentos" separador="equivalentes" />} />
      <Route path="/admin/materiais" element={<AdminRoute><MateriaisHub /></AdminRoute>} />
      <Route path="/admin/conteudos" element={<HubRedirect to="/admin/materiais" separador="conteudos" />} />
      <Route path="/admin/desafios" element={<AdminRoute><AdminDesafiosPage /></AdminRoute>} />
      <Route path="/admin/onboarding" element={<HubRedirect to="/admin/formularios" separador="onboarding" />} />
      <Route path="/admin/calendario" element={<AdminRoute><CalendarioPage /></AdminRoute>} />
      <Route path="/admin/configuracoes" element={<AdminRoute adminOnly><ConfiguracoesHub /></AdminRoute>} />
      <Route path="/admin/backups" element={<HubRedirect to="/admin/dados" separador="backups" />} />
      <Route path="/admin/apagados-recentemente" element={<HubRedirect to="/admin/dados" separador="apagados" />} />
      <Route path="/admin/equipa" element={<AdminRoute adminOnly><AdminTeamPage /></AdminRoute>} />
      <Route path="/admin/tarefas" element={<AdminRoute><TarefasPage /></AdminRoute>} />
      <Route path="/admin/tarefas-automaticas-config" element={<HubRedirect to="/admin/configuracoes" separador="tarefas-automaticas" />} />
      <Route path="/admin/dados" element={<AdminRoute adminOnly><DadosHub /></AdminRoute>} />
      <Route path="/admin/importar-pacientes" element={<HubRedirect to="/admin/dados" separador="importar" />} />
      <Route path="/admin/alimentos-bebes" element={<HubRedirect to="/admin/alimentos" separador="bebes" />} />
      <Route path="/admin/textos-dashboard" element={<HubRedirect to="/admin/comunicacoes" separador="textos-dashboard" />} />
      <Route path="/admin/billing" element={<AdminRoute adminOnly><BillingPage /></AdminRoute>} />
      <Route path="/admin/pagamentos" element={<Navigate to="/admin/financeiro#receita-pagamentos" replace />} />
      <Route path="/admin/comunicacoes" element={<AdminRoute adminOnly><ComunicacoesHub /></AdminRoute>} />
      <Route path="/admin/notificacoes" element={<HubRedirect to="/admin/comunicacoes" separador="notificacoes" />} />
      <Route path="/admin/recomendacoes" element={<AdminRoute><RecomendacoesPage /></AdminRoute>} />
      <Route path="/admin/protocolos" element={<AdminRoute><ProtocolosPage /></AdminRoute>} />
      <Route path="/admin/modelos" element={<HubRedirect to="/admin/materiais" separador="modelos" />} />
      <Route path="/admin/suplementacao" element={<AdminRoute><SuplementacaoHub /></AdminRoute>} />
      <Route path="/admin/suplementacao-templates" element={<HubRedirect to="/admin/suplementacao" separador="suplementacao" />} />
      <Route path="/admin/biblioteca-suplementos" element={<HubRedirect to="/admin/suplementacao" separador="biblioteca" />} />
      <Route path="/admin/formularios" element={<AdminRoute><FormulariosHub /></AdminRoute>} />
      <Route path="/admin/formularios/:id" element={<AdminRoute><AdminFormBuilderPage /></AdminRoute>} />
      <Route path="/admin/formularios/:id/respostas" element={<AdminRoute><AdminFormResponsesPage /></AdminRoute>} />
      <Route path="/admin/guias" element={<HubRedirect to="/admin/materiais" separador="guias" />} />
      <Route path="/admin/anamnese-editor" element={<HubRedirect to="/admin/formularios" separador="anamnese" />} />
      <Route path="/admin/questionarios" element={<AdminRoute><QuestionariosHub /></AdminRoute>} />
      <Route path="/admin/pre-consulta" element={<HubRedirect to="/admin/questionarios" separador="pre-consulta" />} />
      <Route path="/admin/auditoria-pre-consulta" element={<HubRedirect to="/admin/questionarios" separador="auditoria" />} />
      <Route path="/admin/mensagens" element={<AdminRoute><MensagensHub /></AdminRoute>} />
      <Route path="/admin/desempenho" element={<Navigate to="/admin/financeiro#desempenho" replace />} />
      <Route path="/admin/financeiro" element={<AdminRoute><FinanceiroHub /></AdminRoute>} />
      <Route path="/admin/financas-pessoais" element={<HubRedirect to="/admin/configuracoes" separador="financas-pessoais" />} />
      <Route path="/admin/cheques-nutricionista" element={<HubRedirect to="/admin/financeiro" separador="cheques" />} />
      <Route path="/admin/metricas" element={<AdminRoute adminOnly><MetricasHub /></AdminRoute>} />
      <Route path="/admin/ceo" element={<HubRedirect to="/admin/metricas" separador="ceo" />} />
      <Route path="/admin/metricas-mensais" element={<Navigate to="/admin/metricas#metricas-mensais" replace />} />
      <Route path="/admin/metricas-avancadas" element={<Navigate to="/admin/metricas#metricas-avancadas" replace />} />
      <Route path="/admin/disponibilidade" element={<HubRedirect to="/admin/configuracoes" separador="disponibilidade" />} />
      <Route path="/admin/ajuda" element={<AdminRoute adminOnly><HelpPage /></AdminRoute>} />
      <Route path="/admin/receitas-comunidade" element={<HubRedirect to="/admin/receitas" separador="comunidade" />} />
      <Route path="/admin/ementa-fixa" element={<AdminRoute><AdminEmentaFixaPage /></AdminRoute>} />
      <Route path="/admin/feedback-consultas" element={<HubRedirect to="/admin/mensagens" separador="feedback" />} />
      <Route path="/admin/financeiro/categorias" element={<AdminRoute><ExpenseCategoriesPage /></AdminRoute>} />
      <Route path="/admin/pagamentos-equipa" element={<Navigate to="/admin/financeiro#pagamentos-equipa" replace />} />
      <Route path="/admin/pacientes-silencio" element={<HubRedirect to="/admin/inicio" separador="recuperar" />} />
      <Route path="/admin/meus-pagamentos" element={<HubRedirect to="/admin/financeiro" separador="meus-pagamentos" />} />
      <Route path="/admin/minha-conta" element={<AdminRoute><MinhaContaPage /></AdminRoute>} />
      <Route path="/admin/categorias-pacientes" element={<HubRedirect to="/admin/configuracoes" separador="categorias" />} />
      <Route path="/admin/casos-conteudo" element={<HubRedirect to="/admin/marketing" separador="casos" />} />
      <Route path="/admin/diarios" element={<AdminRoute><AdminDiariosPage /></AdminRoute>} />
      <Route path="/admin/whatsapp" element={<HubRedirect to="/admin/comunicacoes" separador="whatsapp" />} />
      <Route path="/admin/lista-espera" element={<AdminRoute><ListaEsperaPage /></AdminRoute>} />
      <Route path="/admin/emails" element={<HubRedirect to="/admin/comunicacoes" separador="emails" />} />
      <Route path="/admin/pagamentos-definicoes" element={<Navigate to="/admin/financeiro#definicoes-pagamentos" replace />} />
      <Route path="/admin/tags" element={<Navigate to="/admin/categorias-pacientes" replace />} />
      <Route path="/admin/menus-migrados" element={<AdminRoute><MenusMigradosPage /></AdminRoute>} />
      <Route path="/admin/pacientes-sem-nutricionista" element={<HubRedirect to="/admin/pacientes" filtro="sem-nutricionista" />} />
      <Route path="/admin/receitas-bebe" element={<HubRedirect to="/admin/receitas" separador="bebe" />} />
      <Route path="/admin/comparar-menus-bebe" element={<AdminRoute><CompararMenusBebePage /></AdminRoute>} />
      <Route path="/admin/marketing/sessoes-gratuitas" element={<HubRedirect to="/admin/marketing" separador="sessoes" />} />
      <Route path="/admin/marketing" element={<AdminRoute adminOnly><MarketingHub /></AdminRoute>} />
      <Route path="/admin/marketing/calendario" element={<HubRedirect to="/admin/marketing" separador="calendario" />} />

      {/* Colaborador (staff sem acesso clínico — ex.: Carlos/Carolina) routes */}
      <Route path="/colaborador/tarefas" element={<ColaboradorRoute><TarefasPage /></ColaboradorRoute>} />

      {/* Marketing (Editor/Viewer externo — acesso isolado ao módulo de marketing) routes */}
      <Route path="/marketing/calendario" element={<MarketingRoute><CalendarioEditorialPage /></MarketingRoute>} />

      {/* Viewer (mentor de negócio / secretária) routes */}
      <Route path="/viewer/dashboard" element={<ViewerRoute><ViewerDashboardPage /></ViewerRoute>} />
      <Route path="/viewer/metricas" element={<ViewerRoute><MetricasAvancadasPage /></ViewerRoute>} />
      <Route path="/viewer/financeiro" element={<ViewerRoute><FinanceiroPage /></ViewerRoute>} />
      <Route path="/viewer/desempenho" element={<ViewerRoute><DesempenhoPage /></ViewerRoute>} />

      <Route path="*" element={<Navigate to={defaultRoute} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ConfirmDialogsProvider>
          <AppRouter />
          <Toaster position="top-center" duration={3000} />
          <SlotConflictDialog />
        </ConfirmDialogsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
